"use client";

import React, { useState, useRef, useEffect } from "react";
import { Autocomplete } from "@react-google-maps/api";
import styles from "../styles/home.module.css";



const SearchBar = ({ setMapCenter, filterNearbyFlats }) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const inputRef = useRef(null);

  const onLoad = (autoC) => setAutocomplete(autoC);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  
  

  const onPlaceChanged = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();
    if (!place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    setMapCenter({ lat, lng }); // Move map to searched location
    filterNearbyFlats(lat, lng); // Show flats within 5km
  };

  return (
    <div className={`${styles.SearchBar} ${isScrolled ? styles.scrolled : ""}`}>
      <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
        <input
          type="text"
          ref={inputRef}
          placeholder="Enter location, city, or zip code"
          className={styles.searchInput}
        />
      </Autocomplete>
    </div>
  );
};

export default SearchBar;
